import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a freestanding two-door fridge/freezer, 0.7 x 0.7 x 1.9 m:
// steel body against the wall on -Z, fridge door above, freezer door below, a
// thin dark gasket line between and vertical bar handles on the left edge.
const STEEL = "#aab2b8";
const DOOR = "#b4bcc2";
const MATTE_BLACK = "#2e2e30";

export const fridge = defineModel({
  id: "fridge",
  batchId: "modern",
  name: "Fridge",
  tags: ["modern", "interior", "appliance", "kitchen", "fridge"],
  summary: "A two-door steel fridge/freezer with vertical bar handles.",
  tiles: { w: 1, h: 1 },
  footprint: 0.8,
  parts(): Part[] {
    return [
      // recessed plinth
      { geometry: new THREE.BoxGeometry(0.62, 0.06, 0.5), color: MATTE_BLACK, position: [0, 0.03, -0.05] },
      // body (back flush at z = -0.35)
      { geometry: new THREE.BoxGeometry(0.7, 1.84, 0.64), color: STEEL, position: [0, 0.98, -0.03] },
      // upper fridge door
      { geometry: new THREE.BoxGeometry(0.66, 1.14, 0.03), color: DOOR, position: [0, 1.3, 0.305] },
      // lower freezer door
      { geometry: new THREE.BoxGeometry(0.66, 0.62, 0.03), color: DOOR, position: [0, 0.37, 0.305] },
      // dark gasket line between the doors
      { geometry: new THREE.BoxGeometry(0.66, 0.04, 0.032), color: MATTE_BLACK, position: [0, 0.7, 0.305] },
      // vertical bar handles (hinge on the right, handles on the left edge)
      { geometry: new THREE.BoxGeometry(0.03, 0.6, 0.03), color: MATTE_BLACK, position: [-0.27, 1.35, 0.345] },
      { geometry: new THREE.BoxGeometry(0.03, 0.34, 0.03), color: MATTE_BLACK, position: [-0.27, 0.46, 0.345] },
    ];
  },
  animations: [],
});
